import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxCaptchaModule } from 'ngx-captcha';
import { ResetPasswordComponent } from '../common/reset-password/reset-password.component';
import { SetNewPasswordComponent } from './set-new-password/set-new-password.component';
import { ProfileComponent } from './profile/profile.component';
import { ProfileListComponent } from './profile/profile-list/profile-list.component';
import { ProfileFormComponent } from './profile/profile-form/profile-form.component';
import { EditPhotoComponent } from './profile/edit-photo/edit-photo.component';
import { AccountSecurityComponent } from './profile/account-security/account-security.component';
import { UserSubscriptionsComponent } from './profile/user-subscriptions/user-subscriptions.component';
import { PaymentMethodComponent } from './profile/payment-method/payment-method.component';
import { NotificationComponent } from './profile/notification/notification.component';
import { CloseAccountComponent } from './profile/close-account/close-account.component';
import { RECAPTCHA_V3_SITE_KEY, ReCaptchaV3Service } from 'ng-recaptcha';

import {
    fas,
    faUser,
    faList,
    faCartShopping,
    faRightLong,
    faArrowRight,
    faBuildingColumns,
    faCartPlus,
} from '@fortawesome/free-solid-svg-icons';

import {
    FontAwesomeModule,
    FaIconLibrary,
} from '@fortawesome/angular-fontawesome';

const userRoutes: Routes = [
    { path: 'login', component: LoginComponent },
    {
        path: 'user-activation/:token',
        component: SetNewPasswordComponent,
    },

    { path: 'reset-password', component: ResetPasswordComponent },

    {
        path: 'user-profile',
        component: ProfileComponent,

        children: [
            //  { path: '', redirectTo: 'edit-profile' ,pathMatch: 'full'}, // Redirect to 'list' by default
            { path: '', redirectTo: 'edit-profile', pathMatch: 'full' },

            { path: 'list', component: ProfileListComponent },
            { path: 'edit-profile', component: ProfileFormComponent },
            { path: 'edit-photo', component: EditPhotoComponent },
            { path: 'edit-account', component: AccountSecurityComponent },
            { path: 'edit-notifications', component: NotificationComponent },
            { path: 'close-account', component: CloseAccountComponent },
            {
                path: 'edit-payment-methods',
                component: PaymentMethodComponent,
            },
        ],
    },

    {
        path: 'manage-subscriptions',
        component: UserSubscriptionsComponent,
    },

    { path: '**', redirectTo: '/not-found' },
];

@NgModule({
    declarations: [
        LoginComponent,
        SetNewPasswordComponent,
        ProfileComponent,
        ProfileListComponent,
        ProfileFormComponent,
        EditPhotoComponent,
        AccountSecurityComponent,
        UserSubscriptionsComponent,
        PaymentMethodComponent,
        NotificationComponent,
        CloseAccountComponent,
        // RvhostLoaderComponent,
    ],

    imports: [
        RouterModule.forChild(userRoutes),
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        ReactiveFormsModule,
        NgxCaptchaModule,

        FormsModule,
        FontAwesomeModule,
        // RecaptchaModule,
        // RecaptchaFormsModule,
    ],

    providers: [
        {
            provide: RECAPTCHA_V3_SITE_KEY,
            useValue: '6Leqi5ooAAAAABIKl01LSDsc1qoSZfmBiSQXJcaR',
        },
        ReCaptchaV3Service,
    ],

    exports: [RouterModule],
})
export class UserModule {
    constructor(library: FaIconLibrary) {
        library.addIconPacks(fas);
        library.addIcons(
            faUser,
            faList,
            faCartShopping,
            faRightLong,
            faArrowRight,
            faBuildingColumns,
            faCartPlus
        );
    }
}
